import dealzyLogoUrl from './dealzy.svg';

const DealzyLogo = ({ width = 60, height = 60, className = '' }) => (
  <img
    src={dealzyLogoUrl}
    alt=""
    width={width}
    height={height}
    className={className}
    aria-hidden="true"
    draggable="false"
  />
);

export default DealzyLogo;
